import { Eye, FilePlus2, ShieldCheck } from "lucide-react";
import { Badge, Button, Card } from "../components/ui";
import { DataTable } from "../components/DataTable";
import { useDocumentTemplates } from "../data/supergestor-data";

export function DocumentBuilderPage() {
  const query = useDocumentTemplates();
  return (
    <div className="page-stack">
      <Card
        title="Construtor de documentos"
        description="Templates versionados, variáveis, preview e aprovações jurídica, privacidade e negócio."
        action={
          <Button>
            <FilePlus2 size={16} /> Novo modelo
          </Button>
        }
      >
        <DataTable
          rows={query.data ?? []}
          getKey={(row) => row.id}
          columns={[
            { key: "name", header: "Modelo", render: (row) => row.name },
            { key: "type", header: "Tipo", render: (row) => row.type },
            { key: "version", header: "Versão", render: (row) => `v${row.version}` },
            {
              key: "status",
              header: "Status",
              render: (row) => <Badge tone="info">{row.status}</Badge>,
            },
            {
              key: "approval",
              header: "Aprovação",
              render: (row) => (
                <Badge tone={row.approval === "APPROVED" ? "success" : "warning"}>
                  {row.approval}
                </Badge>
              ),
            },
            { key: "approvals", header: "Pareceres", render: (row) => row.approvals },
            {
              key: "preview",
              header: "",
              render: () => (
                <Button variant="ghost">
                  <Eye size={15} /> Prévia
                </Button>
              ),
            },
          ]}
        />
      </Card>
      <Card
        title="Gate de assinatura"
        description="Somente versões aprovadas podem ser enviadas ao provedor."
      >
        <div className="task-list">
          <div className="task-item">
            <ShieldCheck size={18} />
            <div>
              <strong>Business + Jurídico + Privacidade</strong>
              <span>A matriz de aprovação é configurável por tipo de documento.</span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
